module.exports = __webpack_public_path__ + "static/media/icon-gift-tree-1.a0af36ed.png";